import useEndTrainingListener from 'hooks/machine/useEndTrainingListener';

export const EndTrainingListener = () => {
  useEndTrainingListener();
  return null;
};
